<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters"  size="mini">
				<el-form-item label="项目名称">
					<el-select v-model="filters.projectId" @change="getDevices" filterable>
						<el-option
							v-for="item in projects"
							:label="item.name"
							:value="item.projectId" :key="item.projectId">
						</el-option >
					</el-select>
				</el-form-item>
				<el-form-item label="点位名称" >
					<el-select v-model="filters.mn" filterable>
						<el-option
							v-for="item in devices"
							:label="item.name"
							:value="item.mnCode" :key="item.mnCode">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="设备编码"  v-if="type==0">
					<el-select v-model="filters.mn" filterable>
						<el-option
							v-for="item in devices"
							:label="item.mnCode"
							:value="item.mnCode" :key="item.mnCode">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="数据类型">
					<el-select v-model="dataType" placeholder="请选择数据类型" >
						<el-option label="分钟" value="minute"></el-option>
						<el-option label="小时" value="hour"></el-option>
						<el-option label="天" value="day"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="时间范围">
					<el-date-picker
                        v-model="filters.time" type="datetimerange" unlink-panels :picker-options="pickerOptions" 
                        range-separator="至"  start-placeholder="开始日期"  end-placeholder="结束日期"  align="right">
                    </el-date-picker>
                </el-form-item>
				<el-form-item>
					<my-button  @select-type="clickBtn" QueryButtonShow ExportButtonShow SettingButtonShow  btnCon="审核"></my-button>
				</el-form-item>
			</el-form>
		</el-col>

		<el-table :data="dataList" border highlight-current-row v-loading="listLoading" style="width: 100%;" :height="formHeight" 
			@selection-change="selsChange"    size="small"  ref="table">
			<el-table-column type="selection"> </el-table-column>
			<el-table-column type="index" label="序号"  fixed></el-table-column>
			<el-table-column prop="time" label="监测时间" width="160" fixed sortable></el-table-column>
			<el-table-column prop="popCon" label="异常信息" width="160" ></el-table-column>
			<el-table-column v-for="item in reviewWays"
				:prop="item.keyword" :label="item.name" :key="item.keyword" >
				<template slot-scope="scope">
					<span v-if="scope.row[item.keyword+'Status']==0">
						<el-button  type="info"  size="small"  disabled>未审核</el-button>
					</span>
					<span v-else-if="scope.row[item.keyword+'Status']==1" >
						<el-button  type="success" size="small" >通过</el-button>
					</span>
					<span v-else >
						<el-button  type="danger"  size="small">无效</el-button>
					</span>
				</template>
			</el-table-column>
			<el-table-column
				v-for="item in facList"
				:prop="item.keyWord" :label="item.title" :key="item.keyWord"  min-width="150">
				<template slot-scope="scope">
					<span v-if="scope.row[item.keyWord]==null" >{{"-"}}</span>
					<span v-else > {{scope.row[item.keyWord]}} </span>
				</template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-pagination layout="total, sizes, prev, pager, next, jumper" @current-change="handleCurrentChange" :page-size="pageSize" :total="total" style="float:right;" 
			:page-sizes="[ 10, 20, 30,40,50]"   @size-change="handleSizeChange" :current-page.sync="page">
			</el-pagination>
		</el-col>

		
		<!-- 审核界面，小时、天、分钟 -->
		<el-dialog :title="SetRecordTitle" :visible.sync="dialogSetRecordVisible"  :append-to-body="true"  width="60%" :close-on-click-modal="false">
			<el-form :model="formSetRecord" label-width="80px" :rules="validRules"  ref="formSetRecord" v-loading="reviewlistLoading">
				<el-form-item label="审核状态"  prop="status">	
					<el-select v-model="formSetRecord.status" placeholder="请选择状态">
						<el-option label="通过" value="1" ></el-option>
						<el-option label="无效" value="2" ></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="选择原因"   prop="reasonId"  v-if="dataType=='hour'||dataType=='minute'">
					<el-select v-model="formSetRecord.reasonId" placeholder="请选择原因" filterable>
						<el-option v-for="item in reasonList" :label="item.name" :value="item.id" :key="item.id"> </el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="标注信息"   prop="remark" >
					<el-input v-model="formSetRecord.remark" ></el-input>
				</el-form-item>
				<el-form-item label="佐证材料"  v-if="dataType=='day'"   prop="img">
					<el-upload class="upload-demo" action="#" ref="upload" name="file" :on-change="change"  accept="image/*" 
						:file-list="fileListShow"  :on-remove="remove"  list-type="picture" multiple :auto-upload="false">
						<el-button size="small" type="primary">点击上传</el-button>
						<div slot="tip" class="el-upload__tip">只能上传图片文件，且最好不超过500kb</div>
					</el-upload>
			</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="cancleSetRecordSubmit">取消</el-button>
				<el-button type="primary" @click.native="reviewDataChildSubmit">提交</el-button>
			</div>
		</el-dialog>
	</section>
</template>

<script>
	import { getProjects,getDevicesByProjectId,fetchExceptionData,getReviewWay,getReasonList,
		reviewMinuteData,reviewDayData,reviewHourData} from '../../api/api';
	import {formatDate,in_array,factorExcept,minFactorExcept,hourFactorExcept} from '../../../static/fun.js';

	import myButton from '../../components/myButton/index.vue'

	export default {
	components: { myButton },
		data() {
			return {
				pickerOptions: {
                    shortcuts: [{
                        text: '最近一天',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
                        picker.$emit('pick', [start, end]);
                        }
                    },{
                        text: '最近一周',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                        }
                    }]
                },
				filters: {
					projectId:"",
					mn:"",
					time:[]
				},
				validRules:{
					status: [
						{ required: true, message: '必选', trigger: 'change'  }
					]
				},
				total: 0,
				page:1,
				pageSize:10,
				listLoading: false,
				dataList:[],
				firstFlag:true,
				devices:[],
				facList:[],
				projects:[],
				formHeight:0,
				dataType:'minute',

				type:sessionStorage.getItem("type"),
				sels:[],
				reviewWays:[],
				dialogSetRecordVisible:false,
				SetRecordTitle:"",
				reasonList:[],
				formSetRecord:{
					status:'',
					reasonId:'',
					remark:''
				},
				reviewlistLoading:false,
				userId:sessionStorage.getItem('userId'),
				fileList:[],
				fileListShow:[]
			}
			
		},
		watch: {
			dataList(val) {
				this.doLayout();
			}
		},
		methods: {
			selsChange: function (sels) {
                this.sels = sels;
			},
			getReasonList() {
				if(this.reasonList.length>0){
					return;
				}
				this.listLoading = true;
				getReasonList().then((res) => {
					this.listLoading = false;
					if(res.data.result=="false"){
                        this.$message({
                            message: "查询出错，请重试",
                            type: 'error'
                        })
						return;
                    }
					this.reasonList = res.data.data;
				});
			},
			//获取因子列表
			getReviewWay() {
				this.listLoading = true;
				getReviewWay({}).then((res) => {
					this.listLoading = false;
					var ways = res.data.data;
					this.reviewWays=[];
					for (let index = 0; index < ways.length; index++) {
						const element = ways[index];
						if(element.keyword!="preReview"){
							this.reviewWays.push(element);//不显示标记信息 因为全是无效
						}
					}
				});
			},
			clickBtn(type){
				if(type=="query"){
					this.getDataList(0);
				}else if(type=="export"){
					this.getDataList(1);
				}else if(type=="setting"){
					//审核
					if(this.sels.length==0){
						this.$message({
							message: "请先勾选数据",
							type: 'warn'
						})
						return;
					}
					this.dialogSetRecordVisible=true;
					this.getReasonList();
					this.formSetRecord.status='2';//默认无效
					if(this.dataType=="minute"){
						this.SetRecordTitle="审核分钟数据";
					}else if(this.dataType=="hour"){
						this.SetRecordTitle="审核小时数据";
					}else{
						this.SetRecordTitle="审核天数据";
					}
				}
			},
			reviewDataChildSubmit(){
				this.$refs.formSetRecord.validate((valid) => {
					if (valid) {
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							let formData = new FormData();
							if(this.userId==""||this.userId==undefined){
								this.$message({
									message: "用户已离线，请重新登录",
									type: 'warn'
								})
								this.$router.push({ path: '/login' });
								return;
							}
							formData.append("status",this.formSetRecord.status);
							formData.append("remark",this.formSetRecord.remark);
							formData.append("mn",this.filters.mn);
							formData.append("userid",this.userId);
							formData.append("ids", this.sels.map(item => item.id).toString());

							this.reviewlistLoading=true;

							if(this.dataType=="hour"){
								if(this.formSetRecord.reasonId!=''){
									formData.append("reasonId",this.formSetRecord.reasonId);
								}
								reviewHourData(formData).then((res) => {
									this.reviewlistLoading=false;
									if(res.data.result==true||res.data.result=="true"){
										this.$message({
											message: "提交成功",
											type: 'success'
										})
										this.dialogSetRecordVisible=false;
										this.$refs.formSetRecord.resetFields();
										this.getDataList(0);
									}else{
										this.$message({
											message: res.data.msg,
											type: 'error'
										})
									}
								}).catch(err => {
									this.reviewlistLoading=false;
									this.$message({
										message: "提交出错，请重试",
										type: 'error'
									})
								});
							}else if(this.dataType=="day"){
								var i=0;
								this.fileList.forEach(file=> {
									formData.append("files"+i, file);
									i++;
								});
								var mns=[];
								for (let index = 0; index < this.sels.length; index++) {
									mns.push(this.filters.mn);
								}
								formData.append("mns", mns.toString());
								//	走接口
								reviewDayData(formData).then(res => {
									this.fileList=[];
									this.fileListShow=[];
									this.reviewlistLoading=false;
									//此处重置文件中间存储变量是为了相同文件能够重复传递
									if (res.data.result==true||res.data.result=="true") {
											this.$message({
												message: '提交成功',
												type: 'success'
											});
											this.dialogSetRecordVisible=false;
											this.$refs.formSetRecord.resetFields();
											this.getDataList(0);
										}else{
											this.$message({
												message: res.data.msg,
												type: 'error'
											})
										}
									})
								.catch(err => {
									this.reviewlistLoading=false;
									this.$message({
										message: "提交出错，请重试",
										type: 'error'
									})
								});	
							}else{
								if(this.formSetRecord.reasonId!=''){
									formData.append("reasonId",this.formSetRecord.reasonId);
								}
								//	走接口
								reviewMinuteData(formData).then(res => {
									this.reviewlistLoading=false;
									//此处重置文件中间存储变量是为了相同文件能够重复传递
									if (res.data.result==true||res.data.result=="true") {
											this.$message({
												message: '提交成功',
												type: 'success'
											});
											this.dialogSetRecordVisible=false;
											this.$refs.formSetRecord.resetFields();
											this.getDataList(0);
										}else{
											this.$message({
												message: res.data.msg,
												type: 'error'
											})
										}
									})
								.catch(err => {
									this.reviewlistLoading=false;
									this.$message({
										message: "提交出错，请重试",
										type: 'error'
									})
								});	
							}
						});
					}
				});
			},
			change:function(file, fileList){
				this.fileList=fileList;
			},
			remove:function(file, fileList){
				this.fileList=fileList;
			},
			cancleSetRecordSubmit(){
				this.dialogSetRecordVisible=false;
				this.$refs.formSetRecord.resetFields();
			},
			doLayout(){
				let that = this
				this.$nextTick(() => {
					that.$refs.table.doLayout()
				})
			},
			handleCurrentChange(val) {
				this.page=val;
				this.getDataList(0);
			},
			handleSizeChange(val){
				this.pageSize=val;
				this.getDataList(0);
			},
			//查询项目信息
			getProjects() {
				this.listLoading = true;
				getProjects().then((res) => {
					this.projects = res.data.data;
					this.listLoading = false;
			        if(this.projects.length>0){
						this.filters.projectId=this.projects[0].projectId;
						this.getDevices();
					}
				});
			},
			//获取设备列表
			getDevices() {
                  let para = {
					projectId: this.filters.projectId
                };
				getDevicesByProjectId(para).then((res) => {
					this.devices = res.data.data;
					//如果当前已选的设备不属于选中的项目，把设备置空
					var flag=false;
					if(this.filters.deviceId!=""){
						this.devices.forEach(item => {
							if(item.mnCode==this.filters.mn){
								flag=true;
							}
						});		
					}
					if(!flag&&this.devices.length>0){
						this.filters.mn=this.devices[0].mnCode;
					}
					if(this.firstFlag){
						this.firstFlag=false;
						this.getDataList(0);
					}
				});
            },
			//获取历史数据信息type 0 查询 1 导出
			getDataList(type){
				this.type=sessionStorage.getItem("type");
				var starttime='';
                var endtime='';
                if(this.filters.time!=null&&this.filters.time.length>0){
                    starttime=formatDate(this.filters.time[0]);
					endtime=formatDate(this.filters.time[1]);
					var day=188;
					if(this.dataType=="minute"){
						day=99;
					}
					if(this.dataType=="day"){
						day=730;
					}
					//如果开始时间超过三个月
					var d1 = new Date(this.filters.time[0]);
					var d2 = new Date(this.filters.time[1]);
					var days=parseInt(d2 - d1) / 1000 / 3600 / 24 ;
					if(days>day){
						this.$message({
							message: "选择时间范围超过"+day+"天",
							type: 'warn'
						})
						return;
					}
                }
				let para = {
					dataType:this.dataType,
					page: this.page,
					limit:this.pageSize,
                    mn: this.filters.mn,
					startTime: starttime,
                    endTime: endtime
				};
				if(this.filters.mn==""){
					this.$message({
						message: "未选择设备",
						type: 'warning'
					})
					return;
				}

				if(type==1){
					para.limit=99999;
				}
				this.listLoading = true;
				fetchExceptionData(para).then((res) => {
					this.listLoading = false;

					if(res.data.code!=0){
                        this.$message({
                            message: "查询失败，请重试",
                            type: 'error'
                        })
						return;
                    }

					if(type==0){//查询
						this.total = res.data.count;
						this.dataList = res.data.data;
						if(this.dataList.length>0){
							this.facList=[];
							var arr=factorExcept();
							var arr2=[];
							if(this.dataType=="minute"){
								arr2=minFactorExcept();
							}else if(this.dataType=="hour"){
								arr2=hourFactorExcept();
							}
							for (var element in this.dataList[0]) {
								if(in_array(element,arr)){
									continue;
								}
								if(in_array(element,arr2)){
									continue;
								}
								var obj=JSON.parse(sessionStorage.getItem(element));
								if(element=="aqi"){
									obj.title=obj.remark;
								}else if(obj.unit.trim()!=""){
									obj.title=obj.remark+'('+obj.unit+')';
								}else{
									obj.title=obj.remark;
								}
								this.facList.push(obj);
							}

							for (let index = 0; index < this.dataList.length; index++) {
								const element = this.dataList[index];
								var json=JSON.parse(element.content);
								if(json.preReview==undefined){
									element.popCon="-";
								}else{
									element.popCon=json.preReview.remark;
								}
								for (let j = 0; j < this.reviewWays.length; j++) {
									const review = this.reviewWays[j].keyword;
									if(json[review]==undefined){
										element[review+"Status"]=0;
									}else{
										element[review+"Status"]=json[review].status;
									}
								}
							}
						}
					}else{//导出
						var dataList = res.data.data;
						if(dataList.length>0){

							var tHeader =  ['时间' ];
							var filterVal = [ 'time'];  

							var arr=factorExcept();
							var arr2=[];
							if(this.dataType=="minute"){
								arr2=minFactorExcept();
							}else if(this.dataType=="hour"){
								arr2=hourFactorExcept();
							}
							for (var element in dataList[0]) {
								if(in_array(element,arr)){
									continue;
								}
								if(in_array(element,arr2)){
									continue;
								}
								var obj=JSON.parse(sessionStorage.getItem(element));
								if(element=="aqi"){
									obj.title=obj.remark;
								}else if(obj.unit.trim()!=""){
									obj.title=obj.remark+'('+obj.unit+')';
								}else{
									obj.title=obj.remark;
								}
								tHeader.push(obj.title);
								filterVal.push(element);
							}

							require.ensure([], () => {
								const { export_json_to_excel } = require('vendor/Export2Excel');

								var data=[];
								var sheetName=[];
								data.push(this.formatJson(filterVal, dataList));
								sheetName.push('Sheet1');

								export_json_to_excel(tHeader, data, '异常数据记录表',sheetName);
							}) 
						}else{
							this.$message({
								message: "查询条件下无数据",
								type: 'warning'
							})
						}
						
					}
				});
			},
			formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },
			SetHeight:function(){
				var hgt=document.getElementsByClassName('content-container')[0].clientHeight;
				var titleHgt=document.getElementsByClassName('tags-view-wrapper')[0].clientHeight;
				var toolbarHgt=document.getElementsByClassName('toolbar')[0].clientHeight+document.getElementsByClassName('toolbar')[1].clientHeight;
				this.formHeight=hgt-titleHgt-toolbarHgt-120;
			},
			setTime(){
				var end = new Date();
				var start = new Date();
				this.dataType="minute";
				start.setTime(start.setDate(start.getDate()-1));
				this.filters.time= [formatDate(start), formatDate(end)];
				this.getProjects();
			},
		},
		mounted() {
			var _this=this;
			var timer=null;
			clearInterval(timer);
			timer =setInterval(function(){
				if(_this.formHeight ==0){
					_this.SetHeight();
				}else{
					clearInterval(timer);
				}
			},10)

			this.getReviewWay();
			
			this.setTime();
		}
	}

</script>

<style>
	.cell{
		text-align: center;
	}
	.timeFar{
		float: right;
		margin-right: 20px;
	}
	.el-form{
		overflow: hidden;
	}
	.el-col-1{
        text-align: center;
    }

	.dataTab{
		margin: 10px;
		margin-top: 0;
		cursor: pointer;
		color: #409eff;
		background: #d9edf7;
	}
	.tabSelect{
		color: #fff;
		background: #409eff;
	}
</style>


// WEBPACK FOOTER //
// ExceptionalData.vue?519ac11c